export class RiskPolicyClient {
  constructor(requestRiskPolicies, authenticationService) {
    this.requestRiskPolicies = requestRiskPolicies;
    this.authenticationService = authenticationService;
    this.API_VERSION = '/v1.1';
  }

  async getUniqueTags() {
    const url = `${this.API_VERSION}/unique-tags`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.requestRiskPolicies.get(url, config);
    return response.data || [];
  }

  async getPolicies(tags, isActiveFirst = false) {
    let url = `${this.API_VERSION}/filter?page[number]=1&page[size]=-1`; // TODO: Esta version traemos todos no manejamos en vista el paginador
    tags.sort().forEach(tag => {
      url += `&filter[tags][]=${tag}`;
    });
    if (isActiveFirst) {
      url += '&sort=-isActive';
    }
    const config = this.defaultAxiosRequestConfig();
    const response = await this.requestRiskPolicies.get(url, config);
    return response.data || [];
  }

  async getPolicyDetails(policyId) {
    const url = `${this.API_VERSION}/${policyId}`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.requestRiskPolicies.get(url, config);
    return response.data || {};
  }

  async isActive(policyId, status) {
    const url = `${this.API_VERSION}/${policyId}/is-active`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.requestRiskPolicies.post(url, { isActive: status }, config);

    return response.data || {};
  }

  async updatePolicy(policy) {
    if (!policy._id) throw new Error('Policy _id is required');
    const url = `${this.API_VERSION}/${policy._id}`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.requestRiskPolicies.patch(url, policy, config);
    return response.data || {};
  }

  async createPolicy(policyData) {
    const url = `${this.API_VERSION}/`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.requestRiskPolicies.post(url, policyData, config);
    return response.data || {};
  }

  defaultAxiosRequestConfig() {
    return {
      headers: this.authenticationService.authHeader()
    };
  }
}
